import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from './components/header/Header';
import { ProgressProvider } from './context/ProgressProvider';
import { StepperProvider } from './context/StepperProvider';
import LegalMentions from './pages/legal-mentions/LegalMentions';
import PrivacyPolicy from './pages/legal-mentions/PrivacyPolicy';
import Simulator from './pages/simulator/Simulator';
import { Theme } from './themes/Theme';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        retry: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false
      },
    }
  })

  const SimulatorPage = () => {
    return (
      <StepperProvider>
        <Simulator />
      </StepperProvider>
    )
  }

  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <ProgressProvider>
        <QueryClientProvider client={queryClient}>
          <Header />
          <main>
            <BrowserRouter>
              <Routes>
                <Route path="/mentions-legales" element={<LegalMentions />}></Route>
                <Route path="/charte-donnees-personnelles" element={<PrivacyPolicy />}></Route>
                <Route path="/:placeId" element={<SimulatorPage />}></Route>
                <Route path="/" element={<SimulatorPage />}></Route>
                <Route path="/*" element={<SimulatorPage />}></Route>
              </Routes>
            </BrowserRouter>
          </main>
        </QueryClientProvider>
      </ProgressProvider>
    </ThemeProvider>
  );
}

export default App;
